import { TextboxMaskedControl } from "@/Common/Components/Inputs/TextboxMaskedControl";
import { SiteCreateState } from "../SiteCreate";

interface ISecuritySectionProps {
    numberBadAccess: number;
    multifactorAuthenticationNumberBadAccess: number;
    periodOfInactivityDays: number;
    mutateState: (mutation: (state: SiteCreateState) => void, then?: () => void) => void;
}

function SecuritySection(props: ISecuritySectionProps): JSX.Element {
    const {
        numberBadAccess,
        multifactorAuthenticationNumberBadAccess,
        periodOfInactivityDays,
        mutateState
    } = props;

    return (
        <div>
            <div className="view-section-header">
                <h3 className="view-section-title">{cacheStore.GetString("SecurityLabel")}</h3>
            </div>
            <div className="view-section-body">
                <div className="row" style={{ marginBottom: "15px" }}>
                    <div className="col-lg-4 col-md-3 col-sm-12 vcenter text-right">
                        <label className="form-label">{cacheStore.GetString("NumberOfFailedLoginLabel")}</label>
                    </div>
                    <div className="col-lg-5 col-md-9 col-sm-12 ">
                        <TextboxMaskedControl
                            id="badLoginInput"
                            value={numberBadAccess.toString()}
                            onChangeFunction={numberBadAccess => mutateState(s => s.numberBadAccess = Number(numberBadAccess))}
                            mask="[9{1,7}"
                            isValid={!IsNullOrWhiteSpace(numberBadAccess.toString()) && numberBadAccess > 0}
                        />
                    </div>
                </div>
                <div className="row" style={{ marginBottom: "15px" }}>
                    <div className="col-lg-4 col-md-3 col-sm-12 vcenter text-right">
                        <label className="form-label">{cacheStore.GetString("MultifactorAuthentication_NumberOfFailedMfaAttemptsLabel")}</label>
                    </div>
                    <div className="col-lg-5 col-md-9 col-sm-12 ">
                        <TextboxMaskedControl
                            value={multifactorAuthenticationNumberBadAccess.toString()}
                            onChangeFunction={numberBadAccess => mutateState(s => s.multifactorAuthenticationNumberBadAccess = Number(numberBadAccess))}
                            mask="[9{1,7}"
                            isValid={multifactorAuthenticationNumberBadAccess > 0}
                        />
                    </div>
                </div>
                <div className="row" style={{ marginBottom: "15px" }}>
                    <div className="col-lg-4 col-md-3 col-sm-12 vcenter text-right">
                        <label className="form-label">{cacheStore.GetString("DeactivateAccountsAfterLabel")}</label>
                    </div>
                    <div className="col-lg-5 col-md-9 col-sm-12 ">
                        <TextboxMaskedControl
                            id="deactivateInput"
                            value={periodOfInactivityDays.toString()}
                            onChangeFunction={period => mutateState(s => s.periodOfInactivityDays = Number(period))}
                            mask="[9{1,3}"
                            isValid={IsNullOrWhiteSpace(periodOfInactivityDays.toString()) || (periodOfInactivityDays > 0 && periodOfInactivityDays <= 999)}
                        />
                    </div>
                    <div className="col-lg-1 col-md-1 col-sm-1" style={{ paddingTop: "7px" }}>
                        {cacheStore.GetString("DaysLabel").toLowerCase()}  {cacheStore.GetString("OfInactivityLabel")}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SecuritySection;
